/**
 * Shared date-range helpers for the staff-monitor feature.
 *
 * The historical API uses a half-open window: `completedAt >= from AND
 * completedAt < to`, where `to` is parsed as midnight UTC. To make a
 * user-facing INCLUSIVE end date actually cover that whole day, callers
 * send `apiTo = addOneDayIso(endDate)`. Keeping the display/state `to`
 * inclusive while the wire `to` is exclusive is the C3 guarantee that the
 * table, CSV, and raw DocumentStats all agree.
 */

export type RangePreset = "today" | "7d" | "30d" | "custom";

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function daysAgoIso(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

export function addOneDayIso(isoDate: string): string {
  const d = new Date(`${isoDate}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}

export function presetRange(preset: RangePreset): { from: string; to: string } {
  const to = todayIso();
  switch (preset) {
    case "today":
      return { from: to, to };
    case "7d":
      return { from: daysAgoIso(6), to };
    case "30d":
      return { from: daysAgoIso(29), to };
    default:
      return { from: daysAgoIso(29), to };
  }
}
